import React from 'react'
const { Fragment } = React

export default class NoMediaBody extends React.Component {

  render() {

    return(
      <Fragment>
        <div className="media-player-box">
          <div className="media-box">
            <div className="media-box-aspect-helper"></div>
            <div className="media-box-content-container align-middle">
              <div className="media-box-content first-upload-box">
                <div className="media-box-icon media-upload-icon"></div>
                <div className="media-box-header">GET STARTED!</div>
                <div className="media-box-body">Simply upload a video or audio file from your computer.</div>
                <div className="media-box-button"><button className="media-button add-media"><span className="icon-add"></span> Add Media</button></div>
              </div>
            </div>
          </div>
        </div>
        <div className="media-player-body">
          <div>
            <div className="media-contents">
              <header className="text-content media-video-title">Sample Title</header>
              <div className="text-content media-description">
                <p>Curabitur blandit tempus porttitor. Vestibulum id ligula porta felis euismod semper. Cras mattis consectetur purus sit amet fermentum. Maecenas faucibus mollis interdum. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Aenean lacinia bibendum nulla sed consectetur. Maecenas faucibus mollis interdum. Curabitur blandit tempus porttitor.</p>
              </div>
            </div>
            <div className="media-meta-data">
              <div className="media-info">
                <div className="text-content media-date"><label>Date</label> Date</div>
                <div className="text-content media-series"><label>Series</label> Series</div>
                <div className="text-content media-speaker"><label>Speaker</label> Speaker</div>
              </div>
            </div>
         </div>
        </div>
      </Fragment>
    )
  }
}
